import styled from 'styled-components'

export const Subtitle = styled.div`
  color: #202020bf;
  font-family: Roboto;
`

export const RequiresApproval = styled.div`
  margin-top: 16px;
  padding: 16px 24px;
  font-family: Roboto;
  background-color: #f5f5f5;
  border-radius: 8px;
  > span {
    color: #363636;
    font-weight: 500;
    font-size: 14px;
  }
  .ant-switch {
    margin-top: 1px;
    float: right;
  }
`

export const Wrapper = styled.div`
  padding-top: 16px;
  > .row {
    margin: 0;
  }
  > .row + .row {
    position: initial;
    button {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`
